import React from 'react';
import { Checkbox, Typography } from 'antd';
import Paragraph from 'antd/es/typography/Paragraph';
import { Form } from 'antd';
import {CertificationByApplicantLegalDisclaimerCredentialAndSendCase} from './certification-by-applicant-legal-disclaimer-credential-and-send-case'
interface CertificationByApplicantLegalDisclaimerProps {
  showAccountEstablishmentAttestation?: boolean;
}

export const CertificationByApplicantLegalDisclaimer: React.FC<CertificationByApplicantLegalDisclaimerProps> = (props) => {
    const CertificationByApplicantLegalDisclaimerIdentityCase = () =>{
      return (
        <div>
          <div>
            <br />
            <Typography.Text strong>
              <p>Account Establishment Attestation</p>
            </Typography.Text>
          </div>

          <Paragraph>
            I hereby certify that the information that I have provided to establish a Credential Verification for Health Professionals (CVHP) Account was provided solely by me
            and is true and correct to the best of my knowledge. I understand that the decision as to whether I qualify for a CVHP Account or to receive any ECFMG services
            rests solely and exclusively with ECFMG and that ECFMG's decision-making authority is ongoing. I certify I understand that, among other things, ECFMG may report
            actual or suspected activities of irregular behavior to the entity to which I am applying; to U.S. and international medical registration and licensing
            authorities; educational institutions; places of employment; and/or any other organization or individual who, in the sole judgment of ECFMG has a legitimate
            interest in such information and/or where such disclosure is necessary for ECFMG to provide the requested services, and such reporting could result in actions to
            my professional practice, among other things. I understand that irregular behavior includes my submission of falsified documents and/or information to ECFMG as
            part of the services provided to me and/or other activities on my part that would or could subvert ECFMG’s processes and procedures.{' '}
          </Paragraph>
          <div>
            <Form.Item
              name={['isAttestationComplete', 'understandTerms']}
              valuePropName="checked"
              rules={[
                {
                  validator: (_, value) => (value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms')))
                }
              ]}
            >
              <Checkbox defaultChecked={true}>
                By checking this box, I certify that I have read, understood, and agree to the terms of the Credential Verification for Health Professionals (CVHP) Account
                Establishment Attestation as described above and agree to be legally bound by them.
              </Checkbox>
            </Form.Item>
            <br />
          </div>
        </div>
      )
    }

  return (
    <div>
      {props.showAccountEstablishmentAttestation ? (
        <div className="border-4 border-black legal-textbox-scrollbar"
        style={{ border: '1px solid black', height: '400px', width:'100%', textAlign:'justify', marginLeft:'0.5%', marginRight:'0.5%',marginTop: '1%', padding: '2%', overflowX: 'hidden', overflowY: 'scroll' }}>
          {CertificationByApplicantLegalDisclaimerIdentityCase()} 
          <CertificationByApplicantLegalDisclaimerCredentialAndSendCase showAccountEstablishmentAttestation={true}/>
        </div>
      ) : (
        <CertificationByApplicantLegalDisclaimerCredentialAndSendCase />
      )}
    </div>
  );
};

